module.exports = __webpack_public_path__ + "/images/promos_landing.33640cc.webp";